import { EmptyValueDash } from './EmptyValueDash';
import { displayCurrency } from '../../../../../utils/DisplayCurrency';
import { CustomerRow } from '../../../CustomersV2.types';

export const ApprovedLimitCell = ({ row }: { row: CustomerRow }) => {
  if (row.limit_amount === null) {
    return (
      <EmptyValueDash row={row} reason="A limit hasn't been calculated yet." />
    );
  }
  return <div>{displayCurrency(row.limit_amount)}</div>;
};
